import {EntityService} from '../../../service/EntityService';

export class ProductService extends EntityService {

  static entity = 'app/product';
  static updateChangeTax(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/change-tax`, data).then(res => res.data);
  }
}
